import React from 'react';

export default ({ className }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
    <polygon fillRule="evenodd" points="6.649 4.667 7.975 9.367 8.025 9.367 9.351 4.667 11.333 4.667 9.199 11.333 6.801 11.333 4.667 4.667"/>
  </svg>
);
